export default __webpack_public_path__ + "static/media/cup.3556a4a9.png";